<template>
  <FullPage>
    <Webview>
      <Header title="刪除帳號" :back="back"></Header>
      <div class="form _fill">
        <div class="warning">
          <span class="icon">⚠️</span>
          <span class="text">{{$tp("settingPage.confirm.deleteAccount")}}</span>
        </div>
        <label class="confirm-check">
          <input type="checkbox" v-model="isConfirmed" />{{$tp("settingPage.confirm.deleteAccount2")}}
        </label>
      </div>
      <div class="wv_button">
        <div class="main_btn _delete delete" :class="{ disabled: !isConfirmed }" :disabled="!isConfirmed" @click="onDeleteUserMe">{{$tp("slot.delete", { label: this.$tp("label.account") })}}</div>
        <Version />
      </div>
    </Webview>
    <router-view />
  </FullPage>
</template>

<script>
import { deleteUserMe } from "@/api/userMe";

export default {
  mixins: [
    require("@mix/form").default,
  ],
  computed: {
    BUILD_VERSION: () => BUILD_VERSION
  },
  data() {
    return {
      isConfirmed: false,
    }
  },
  methods: {
    back() {
      this.$router.replace({ path: "/setting" });
    },
    async onDeleteUserMe() {
      if (!this.isConfirmed) return;

      CONFIRM({
        type: "delete",
        text: this.$tp("settingPage.warn.deleteAccount"),
        label_submit: this.$tp("slot.delete", { label: this.$tp("label.account") }),
        close: () => { },
        submit: async () => {
          try {
            const res = await deleteUserMe();
            if (res) {
              this.$store.commit("SET_IS_LOGIN", false);
            }
          }
          catch (error) {
            NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: this.$tp("label.delete") }));
          }
        },
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.warning {
  padding: 12px;
  background-color: #fff6f6;
  color: #d9534f;
  border-radius: 8px;
  margin-bottom: 12px;
  font-size: 14px;
  line-height: 1.5;

  display: flex;
  align-items: flex-start;
  white-space: pre-wrap;

  .text {
    padding-left: 1em;
  }
}
.confirm-check {
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 12px;

  white-space: pre-wrap;

  input {
    margin-right: 8px;
  }
}
.main_btn.disabled {
  background-color: #ccc !important;
  pointer-events: none;
}
</style>